import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Field} from 'react-final-form';
import {useDispatch, useSelector} from 'react-redux';
import {FieldArray} from 'react-final-form-arrays';
import t from 'babel-plugin-yate/macro';
import {hasItems} from '../lib/validations';
import {getMarketingContactMethods} from '../store/request';
import Condition from '../components/Condition';
import Checkbox from '../components/Form/Checkbox';
import ValidationError from '../components/Form/ValidationError';
import Label from '../components/Form/Label';

function ContactMode(props) {
  const {uuid} = useParams();
  const dispatch = useDispatch();
  const {disabled, prefix = ''} = props;
  const marketingContactMethods = useSelector(
    state => state.request.marketingContactMethods,
  );

  useEffect(() => {
    if (!marketingContactMethods) dispatch(getMarketingContactMethods(uuid));
  }, [uuid, dispatch, marketingContactMethods]);

  if (!marketingContactMethods) {
    return [];
  }

  const fieldName = `customer.detail.${prefix}marketing_contact_mode`;
  const allMethods = marketingContactMethods.filter(
    method => method.display !== false,
  );

  return (
    <Condition when="customer.agreement.has_marketing" is={true}>
      <div className="pt-3 flex flex-wrap">
        <div className="pl-5 w-full">
          <Label value={t`Preferred contact method`} />
        </div>

        <FieldArray name={fieldName} validate={hasItems()}>
          {({fields, meta}) => {
            const currentValues = fields.value || [];
            const isAllChecked = allMethods.every(method =>
              currentValues.includes(String(method.id)),
            );

            return (
              <>
                <div className="w-full pl-5">
                  <Field
                    name="select_all"
                    label={t`Selecteaza toate`}
                    component={Checkbox}
                    type="checkbox"
                    checked={isAllChecked}
                    onChange={({target: {checked}}) => {
                      if (checked) {
                        allMethods.forEach(method => {
                          if (!currentValues.includes(String(method.id))) {
                            fields.push(String(method.id));
                          }
                        });
                      } else {
                        for (let i = fields.length - 1; i >= 0; i--) {
                          fields.remove(i);
                        }
                      }
                    }}
                  />
                </div>

                {allMethods.map(method => (
                  <div className="w-full pl-5" key={method.id}>
                    <Field
                      name={fieldName}
                      label={method.name}
                      component={Checkbox}
                      type="checkbox"
                      value={String(method.id)}
                      disabled={disabled}
                      showError={false}
                    />
                  </div>
                ))}

                {meta.error && meta.touched && (
                  <div className="w-full pl-5">
                    <ValidationError value={meta.error} />
                  </div>
                )}
              </>
            );
          }}
        </FieldArray>
      </div>
    </Condition>
  );
}

export default ContactMode;
